@if (ENABLE_SEC_GRID_CHART_MMC) {
    @if (!allUncategorized && categoryTargetPercent && categoryTargetPercent.length !== 0) {
        <div class="ac-detail-section">
            <div class="dblock bold" style="font-size: 14px; padding: 0 0 5px 0;">Asset Category</div>
            <div class="ac-detail-content">
                <div class="ac-detail-card">
                    <div class="dblock bold">Allocations</div>
                    <div class="ac-detail-table">
                        <mat-table [dataSource]="categoryTableDataSource">
                            <ng-container matColumnDef="category">
                                <mat-header-cell *matHeaderCellDef>Category</mat-header-cell>
                                <mat-cell *matCellDef="let row">
                                    <div style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">{{row.category}}</div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="color">
                                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                                <mat-cell *matCellDef="let row">
                                    <div class="key" [style.backgroundColor]="row.colorCode"></div>
                                </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="categoryTableColumns; sticky: false"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: categoryTableColumns"></mat-row>
                        </mat-table>
                    </div>
                </div>
                <div class="ac-detail-card">
                    <div class="dblock bold">Allocation</div>
                    <div style="display: flex; justify-content: center; align-items: center;">
                        <p-chart type="doughnut" [data]="chartData" [options]="options"
                                 width="270px" height="270px"></p-chart>
                    </div>
                </div>
            </div>
        </div>
    }
} @else {
    <div class="model-security-allocations-chart">
        <div class="block">
            <div class="chart">
                <p-chart type="doughnut" [data]="chartData" [options]="options"
                         width="250px" height="250px"></p-chart>
            </div>
        </div>
        @if (categoryTargetPercent && categoryTargetPercent.length !== 0) {
            <div>
                <div class="model-security-allocations-chart-custcat">By {{categoryLabel}}</div>
                <div>
                    @for (lst of objectOfCategoryLists.lists; track $index) {
                        <div class="model-security-allocations-chart-list">
                            @for (item of lst; track $index) {
                                <div class="model-security-allocations-chart-item">
                                    <div class="model-security-allocations-chart-custcat-color" [style.backgroundColor]="getColorByCategory(item.category)"></div>
                                    <div class="model-security-allocations-chart-item-category">{{item.category}}</div>
                                    @if (!noTarget) {
                                        <div class="model-security-allocations-chart-item-target">{{item.targetPercent}} %</div>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        }
    </div>
}

@if (ENABLE_SEC_GRID_CHART_MMC && sacLevel1Allocations && sacLevel1Allocations.length > 0) {
    <div class="ac-detail-section">
        <div class="dblock bold" style="font-size: 14px; padding: 15px 0 5px 0;">Asset Class Detail</div>
        <div class="ac-detail-content">
            <div class="ac-detail-card">
                <div class="dblock bold">Allocations</div>
                <div class="ac-detail-table">
                    <mat-table [dataSource]="sacLevel1TableDataSource">
                        <ng-container matColumnDef="category">
                            <mat-header-cell *matHeaderCellDef>Category</mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                <div style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">{{row.category}}</div>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="color">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                <div class="key" [style.backgroundColor]="row.colorCode"></div>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="sacLevel1TableColumns; sticky: false"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: sacLevel1TableColumns"></mat-row>
                    </mat-table>
                </div>
            </div>
            @if (sacLevel1ChartData) {
                <div class="ac-detail-card">
                    <div class="dblock bold">Allocation</div>
                    <div style="display: flex; justify-content: center; align-items: center;">
                        <p-chart type="doughnut" [data]="sacLevel1ChartData" [options]="sacLevel1DoughnutOptions"
                                 width="270px" height="270px"></p-chart>
                    </div>
                </div>
            }
        </div>
    </div>
}
